import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f790671e")

_pushScopeId("data-v-f790671e")
const _hoisted_1 = { class: "toolbar" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentTabs, (tab) => {
        return (_openBlock(), _createBlock("div", {
          class: ["tab", { 'active': tab.value === _ctx.toolbarState }],
          key: tab.value,
          onClick: ($event: any) => (_ctx.setToolbarState(tab.value))
        }, _toDisplayString(tab.label), 11, ["onClick"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_3, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentPanelComponent)))
    ])
  ]))
})